import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

export const fetchLocation = createAsyncThunk(
  "location/fetchLocation",
  async (companyCode, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${Api_EndPoints.PayrollURL}${Api_EndPoints.LocationAPI}?isAll=true&CompanyCode=${companyCode}`
      );
      console.log("res",response.data)
      return response.data;
    } catch (error) {
      return rejectWithValue({
        message: error.response?.data?.message || error.message, // More specific error message
        status: error.response?.status, // Include status code if available
      });
    }
  }
);

const locationSlice = createSlice({
  name: "location",
  initialState: {
    data: null, // Or [], depending on your preference
    loading: false,
    error: null,
  },
  reducers: {
    resetLocation: (state) => {
      state.data = null;
      state.error = null; // Clear error on reset
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocation.fulfilled, (state, action) => {
        console.log("fetchLocation.fulfilled payload:", action.payload); // Check payload
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchLocation.rejected, (state, action) => {
        console.error("fetchLocation.rejected error:", action.payload); // Check error
        state.loading = false;
        state.error = {
          /* ... */
        };
      })
      .addCase(fetchLocation.pending, (state) => {
        console.log("fetchLocation.pending error:", state); // Check error
        state.loading = true;
        state.error = null; // Clear previous errors
      });

    // builder

    //     .addCase(fetchLocation.fulfilled, (state, action) => {
    //         state.loading = false;
    //         state.data = action.payload;
    //     })
    //     .addCase(fetchLocation.rejected, (state, action) => {
    //         state.loading = false;
    //         state.error = {
    //             message: action.payload?.message || action.error.message,
    //             status: action.payload?.status || action.error.status,
    //         };
    //     });
  },
});

export const { resetLocation } = locationSlice.actions;
export const selectLocationData = (state) => state.location.data;
export const selectLocationLoading = (state) => state.location.loading;
export const selectLocationError = (state) => state.location.error;
export default locationSlice.reducer;
